import {sdkTextElement, sdkMessageElement, localizeSdkElement} from '../i18n/sdk-text';
import React from 'react';
import {createComponents,SLOGAN} from './components.js';
import './op-cards.css';
import './sdk-integration.css';
export const OpCardRuntimeContext=React.createContext(null);
export const {OpCardHub,OpCardOwnedView,OpCardOpening}=createComponents(React);

export function OpCardHomeEntry(){return <OpCardRuntimeContext.Consumer>{binding=>binding&&binding.readsEnabled===true
 ? <div className="opcards-home-entry"><button type="button" onClick={()=>binding.pendingPacks&&binding.pendingPacks.known&&binding.pendingPacks.pending?binding.openInventory():binding.openHub('permanent')}>
  <span>{sdkTextElement("OP \u5178\u85CF\u5361\u5305")}</span>{binding.pendingPacks&&binding.pendingPacks.known&&binding.pendingPacks.pending&&localizeSdkElement(<span className="opcards-pending-dot" role="img" aria-label="有尚未揭開的卡包" />, {
  "aria-label": ["\u6709\u5C1A\u672A\u63ED\u958B\u7684\u5361\u5305"]
})}
 </button></div>:null}</OpCardRuntimeContext.Consumer>;}

export function OpCardEntrySlot(){
 return <OpCardRuntimeContext.Consumer>{binding=>binding&&binding.readsEnabled===true
  ? localizeSdkElement(<nav className="opcards-entries opcards-sdk-entries" aria-label="OP 典藏卡包">
    <button type="button" className="opcards-entry opcards-entry-red" onClick={() => binding.openHub('permanent')}>
     <strong>{sdkTextElement("OP \u5178\u85CF\u5361\u5305")}</strong><span>{sdkTextElement(SLOGAN)}</span><small>{sdkTextElement("2\uFF0F3\uFF0F5\uFF0F10 \u5305 \xB7 \u9EDE\u64CA\u67E5\u770B")}</small>
     {binding.limitedActivity && <span className="opcards-limited-badge"><b>{sdkTextElement("\u9650\u6642\u5408\u8F2F\u9032\u884C\u4E2D")}</b><span>{sdkMessageElement("\u5269\u9918 {{v0}}", {
          v0: binding.limitedActivity.countdown
        })}</span></span>}
    </button>
   </nav>, {
  "aria-label": ["OP \u5178\u85CF\u5361\u5305"]
})
  : null}</OpCardRuntimeContext.Consumer>;
}
